const appConfig = Object.freeze({
  name: 'Votum',
  version: '2.0',
  storagePrefix: 'votum',
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || '/api',
});

export default appConfig;
